import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import ar from "../locales/ar.json";
import fr from "../locales/fr.json";
import { getUserLanguage } from "../utils/getUserLanguage";

i18next.use(initReactI18next).init({
  lng: getUserLanguage(),
  fallbackLng: "en",
  debug: false,
  resources: {
    en: {
      translation: en,
    },
    ar: {
      translation: ar,
    },
    fr: {
      translation: fr,
    },
  },
});

export default i18next;
